export const fetchAllInvoicesQueryKey = () => ['invoices'];
export const getInvoiceQueryKey = (invoiceId: number | string | undefined) => [
  'invoice',
  invoiceId || 0,
];
